import React from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import RegistrationForm from "../components/RegistrationForm";
import PrivateRoute from "../components/PrivateRoute";
import StockForm from "../components/products/StockForm";
import MenuComponent from "../components/MenuComponent";
import AccountSettingsForm from "../components/accounting/AccountSettingsForm";
import UpdatePasswordForm from "../utils/UpdatePasswordForm";
import Users from "../components/utils/Users";
import DeveloperSettingsForm from "../components/accounting/DeveloperSettingsForm";
import MenuRoutesForm from "../components/inventory/MenuRoutesForm";
import CustomerForm from "../components/inventory/CustomerForm";
import PermissionsForm from "../components/inventory/PermissionsForm";
import Dashboard from "../components/Dashboard";
import AccountForm from "../components/products/AccountForm";
import WarehouseForm from "../components/inventory/WarehouseForm";
import EmployeeForm from "../components/payroll/EmployeeForm";
import AreaForm from "../components/inventory/AreaForm";
import PensionLoanForm from "../components/inventory/PensionLoanForm";
import AccountGroupForm from "../components/inventory/AccountGroupForm";
import BankForm from "../components/inventory/BankForm";
import BranchForm from "../components/inventory/BranchForm";
import ClaimTypeForm from "../components/inventory/ClaimTypeForm";
import AccountStatusForm from "../components/inventory/AccountStatusForm";
import CollectionTypeForm from "../components/inventory/CollectionTypeForm";
import TransactionTypeForm from "../components/inventory/TransactionTypeForm";
import RoleForm from "../components/inventory/RoleForm";
import CompanyForm from "../components/inventory/CompanyForm";
import AttendanceForm from "../components/payroll/AttendanceForm";
import PayrollForm from "../components/payroll/PayrollForm";
import DeductionForm from "../components/payroll/DeductionForm";
import ScheduledDeductionForm from "../components/payroll/ScheduledDeductionForm";
import PayrollCheckVoucherForm from "../components/payroll/PayrollCheckVoucherForm";
import CategoryForm from "../components/inventory/CategoryForm";
import StockBranchPricingForm from "../components/products/StockBranchPricingForm";
import WholesaleStockBranchPricingForm from "../components/products/WholesaleStockBranchPricingForm";
import StocksReceiving from "../components/inventory/StocksReceiving";
import StockTransferForm from "../components/inventory/StockTransferForm";
import DisplayDeliveryReceiptForm from "../components/inventory/DisplayDeliveryReceiptForm";
import DeliveryReceiptForm from "../components/inventory/DeliveryReceiptForm";
import { PAYMENT_TYPE_CASH, PAYMENT_TYPE_CHARGE } from "../utils/constants";
import PurchaseReturnForm from "../components/inventory/PurchaseReturnForm";
import ReturnStockForm from "../components/inventory/ReturnStockForm";
import CreditMemoForm from "../components/inventory/CreditMemoForm";
import BranchInventoryBalanceList from "../components/inventory/BranchInventoryBalanceList";
import StockCardReport from "../components/inventory/StockCardReport";
import InventoryAdjustmentForm from "../components/inventory/InventoryAdjustmentForm";
import PhysicalCountForm from "../components/inventory/PhysicalCountForm";
import PaymentMethodForm from "../components/inventory/PaymentMethodForm";
import CustomerCollectionForm from "../components/inventory/CustomerCollectionForm";
import StatementOfAccountForm from "../components/inventory/StatementOfAccountForm";
import CashSalesReport from "../components/inventory/CashSalesReport";
import ChargeSalesReport from "../components/inventory/ChargeSalesReport";
import CustomerCollectionReport from "../components/inventory/CustomerCollectionReport";
import ReplacementForm from "../components/inventory/ReplacementForm";
import LeavesAvailedReport from "../components/payroll/LeavesAvailedReport";
import CustomerAgingSummary from "../components/inventory/CustomerAgingSummary";
import CustomerAgingDetails from "../components/inventory/CustomerAgingDetails";
import AccountLedgerReport from "../components/inventory/AccountLedgerReport";
import AccountLedgerSummaryReport from "../components/inventory/AccountLedgerSummaryReport";
import StocksReceivingHistory from "../components/inventory/StocksReceivingHistory";
import StockTransferHistory from "../components/inventory/StockTransferHistory";
import CreditMemoHistory from "../components/inventory/CreditMemoHistory";
import ReplacementReport from "../components/inventory/ReplacementReport";
import OldStatementOfAccountForm from "../components/inventory/OldStatementOfAccountForm";
import ReturnStockReport from "../components/inventory/ReturnStockReport";
import CategorySalesReport from "../components/inventory/CategorySalesReport";
import PettyCashVoucherForm from "../components/inventory/PettyCashVoucherForm";
import PettyCashVoucherReport from "../components/inventory/PettyCashVoucherReport";
import SupplierForm from "../components/inventory/SupplierForm";
import ProjectForm from "../components/products/ProjectForm";

import ProjectEstimatesForm from "../components/inventory/ProjectEstimatesForm";
import BillingStatementForm from "../components/inventory/BillingStatementForm";
import ProjectTypeForm from "../components/inventory/ProjectTypeForm";
import ReasonForm from "../components/inventory/ReasonForm";
import ProjectReport from "../components/reports/ProjectReport";
import PurchaseOrderForm from "../components/inventory/PurchaseOrderForm";
import WarehouseWithdrawalForm from "../components/inventory/WarehouseWithdrawalForm";
import PurchaseRequestForm from "../components/inventory/PurchaseRequestForm";
import ComparativeSlipForm from "../components/inventory/ComparativeSlipForm";
import CheckVoucherForm from "../components/inventory/CheckVoucherForm";
import CheckVoucherPrintout from "../components/inventory/CheckVoucherPrintout";
import CheckPrintout from "../components/inventory/CheckPrintout";
import ExpenseCategoryForm from "../components/inventory/ExpenseCategoryForm";
import PurchaseRequestPrintout from "../components/inventory/PurchaseRequestPrintout";
import PurchaseOrderPrintout from "../components/inventory/PurchaseOrderPrintout";
import ProjectEstimatePrintout from "../components/inventory/ProjectEstimatePrintout";
import WarehouseWithdrawalPrintout from "../components/inventory/WarehouseWithdrawalPrintout";
import ReturnStockPrintout from "../components/inventory/ReturnStockPrintout";
import StockReceivingPrintout from "../components/inventory/StockReceivingPrintout";
import AdditionalProjectEstimateForm from "../components/inventory/AdditionalProjectEstimateForm";
import BillingStatementReport from "../components/inventory/BillingStatementReport";
import ProjectEstimateReport from "../components/inventory/ProjectEstimateReport";
import PurchaseRequestReport from "../components/inventory/PurchaseRequestReport";
import PurchaseOrderReport from "../components/inventory/PurchaseOrderReport";
import WarehouseWithdrawalReport from "../components/inventory/WarehouseWithdrawalReport";
import InventoryAdjustmentReport from "../components/inventory/InventoryAdjustmentReport";
import PhysicalCountReport from "../components/inventory/PhysicalCountReport";
import CheckVoucherReport from "../components/inventory/CheckVoucherReport";
import DebitMemoForm from "../components/inventory/DebitMemoForm";
import DebitMemoPrinout from "../components/inventory/DebitMemoPrinout";
import AdditionalProjectEstimatePrintout from "../components/inventory/AdditionalProjectEstimatePrintout";
import InternalRepairForm from "../components/inventory/InternalRepairForm";
import FormulationForm from "../components/inventory/FormulationForm";
import ProductionForm from "../components/inventory/ProductionForm";
import ProductionPrinout from "../components/inventory/ProductionPrinout";
import DeliveryReportPrintout from "../components/inventory/DeliveryReportPrintout";
import InventoryAdjustmentPrintout from "../components/inventory/InventoryAdjustmentPrintout";
import CustomerCollectionPrintout from "../components/inventory/CustomerCollectionPrintout";
import IssuanceForm from "../components/inventory/IssuanceForm";
import ProductionHistory from "../components/inventory/ProductionHistory";
import ProcessedReport from "../components/inventory/ProcessedReport";
import IssuanceReport from "../components/inventory/IssuanceReport";
import IssuancePrintout from "../components/inventory/IssuancePrintout";
import DeliveriesReport from "../components/inventory/DeliveriesReport";
import WarehouseTransferForm from "../components/inventory/WarehouseTransferForm";
import WarehouseTransferPrintout from "../components/inventory/WarehouseTransferPrintout";
import DailyLedgerReport from "../components/inventory/DailyLedgerReport";
import DailyInventoryLedgerReport from "../components/inventory/DailyInventoryLedgerReport";
import WaiterForm from "../components/categories/WaiterForm";
import NotesForm from "../components/inventory/NotesForm";
import PrinterStationForm from "../components/inventory/PrinterStationForm";
import MainCategoryForm from "../components/inventory/MainCategoryForm";
import DiscountForm from "../components/inventory/DiscountForm";
import OtherPaymentForm from "../components/inventory/OtherPaymentForm";
import DeliveryReceiptItemsReport from "../components/inventory/DeliveryReceiptItemsReport";
import WarehouseReceiptItemsReport from "../components/inventory/WarehouseReceiptItemsReport";
import CondimentsForm from "../components/inventory/CondimentForm";
import AllSalesListings from "../components/products/AllSalesListings";
import XreadListings from "../components/products/XreadListings";
import ZreadListings from "../components/products/ZreadListings";
import TieupForm from "../components/categories/TieupForm";
import TieupProductForm from "../components/inventory/TieupProductForm";
import OtherPaymentListings from "../components/sales/OtherPaymentListings";
import SalesChannelSalesPerPeriodCovered from "../components/reports/SalesChannelSalesPerPeriodCovered";
import PaymentMethodPerSalesChannel from "../components/reports/PaymentMethodPerSalesChannel";
import BranchInventoryReport from "../components/inventory/BranchInventoryReport";
import AverageSalesPerPaxPerDay from "../components/reports/AverageSalesPerPaxPerDay";
import SalesChannelForm from "../components/inventory/SalesChannelForm";

const AppRouter = () => (
  <div className="is-full-height">
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginForm />} exact={true} />
        <Route path="/" element={<LoginForm />} exact={true} />

        <Route path="/dashboard" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={Dashboard} />}
          ></Route>
        </Route>

        <Route path="/areas" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={AreaForm} />}
          ></Route>
        </Route>

        <Route path="/products" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={
              <MenuComponent
                component={StockForm}
                form_title="Products"
                product_type={{ $ne: "Menu Items" }}
              />
            }
          ></Route>
        </Route>
        <Route path="/menu-items" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={
              <MenuComponent
                component={StockForm}
                product_type="Menu Items"
                form_title="Menu Items"
              />
            }
          ></Route>
        </Route>
        <Route
          path="/stock-branch-pricing"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StockBranchPricingForm} />}
          ></Route>
        </Route>
        <Route
          path="/wholesale-stock-branch-pricing"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={
              <MenuComponent component={WholesaleStockBranchPricingForm} />
            }
          ></Route>
        </Route>
        <Route path="/categories" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CategoryForm} />}
          ></Route>
        </Route>
        <Route path="/waiters" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={WaiterForm} />}
          ></Route>
        </Route>
        <Route path="/notes" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={NotesForm} />}
          ></Route>
        </Route>
        <Route path="/condiments" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CondimentsForm} />}
          ></Route>
        </Route>

        <Route path="/printer-stations" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PrinterStationForm} />}
          ></Route>
        </Route>
        <Route path="/main-categories" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={MainCategoryForm} />}
          ></Route>
        </Route>
        <Route path="/discounts" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={DiscountForm} />}
          ></Route>
        </Route>

        <Route path="/accounts" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={AccountForm} />}
          ></Route>
        </Route>

        <Route path="/warehouses" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={WarehouseForm} />}
          ></Route>
        </Route>
        <Route path="/projects" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={ProjectForm} />}
          ></Route>
        </Route>
        <Route path="/project-types" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={ProjectTypeForm} />}
          ></Route>
        </Route>
        <Route path="/reasons" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={ReasonForm} />}
          ></Route>
        </Route>

        <Route path="/sales-channels" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={SalesChannelForm} />}
          ></Route>
        </Route>

        <Route
          path="/billing-statement"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={BillingStatementForm} />}
          ></Route>
        </Route>
        <Route
          path="/billing-statement/:id"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={BillingStatementForm} />}
          ></Route>
        </Route>
        <Route
          path="/project-estimates"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ProjectEstimatesForm} />}
          ></Route>
        </Route>

        <Route
          path="/project-estimates/:id"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ProjectEstimatesForm} />}
          ></Route>
        </Route>
        <Route
          path="/additional-project-estimates"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={
              <MenuComponent component={AdditionalProjectEstimateForm} />
            }
          ></Route>
        </Route>
        <Route
          path="/warehouse-withdrawals"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={WarehouseWithdrawalForm} />}
          ></Route>
        </Route>
        <Route path="/formulations" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={FormulationForm} />}
          ></Route>
        </Route>
        <Route path="/production" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={ProductionForm} />}
          ></Route>
        </Route>
        <Route path="/internal-repairs" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={InternalRepairForm} />}
          ></Route>
        </Route>
        <Route path="/purchase-orders" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PurchaseOrderForm} />}
          ></Route>
        </Route>
        <Route
          path="/purchase-requests"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PurchaseRequestForm} />}
          ></Route>
        </Route>
        <Route
          path="/comparative-slips"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ComparativeSlipForm} />}
          ></Route>
        </Route>

        <Route path="/customers" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CustomerForm} />}
          ></Route>
        </Route>

        <Route path="/menu-routes" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={MenuRoutesForm} />}
          ></Route>
        </Route>
        <Route path="/permissions" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PermissionsForm} />}
          ></Route>
        </Route>
        <Route path="/roles" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={RoleForm} />}
          ></Route>
        </Route>

        <Route path="/update-password" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={UpdatePasswordForm} />}
          ></Route>
        </Route>

        <Route path="/account-settings" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={AccountSettingsForm} />}
          ></Route>
        </Route>

        <Route path="/pension-loans" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PensionLoanForm} />}
          ></Route>
        </Route>
        <Route path="/account-groups" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={AccountGroupForm} />}
          ></Route>
        </Route>

        <Route path="/users" element={<PrivateRoute />} exact={true}>
          <Route path="" element={<MenuComponent component={Users} />}></Route>
        </Route>

        {/* Reports */}

        <Route
          path="/reports/average-sales-per-pax-per-day"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={AverageSalesPerPaxPerDay} />}
          ></Route>
        </Route>

        <Route
          path="/payment-method-per-sales-channel"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PaymentMethodPerSalesChannel} />}
          ></Route>
        </Route>
        <Route
          path="/sales-channel-sales-per-period-covered"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={
              <MenuComponent component={SalesChannelSalesPerPeriodCovered} />
            }
          ></Route>
        </Route>
        <Route
          path="/developer-settings"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DeveloperSettingsForm} />}
          ></Route>
        </Route>
        <Route path="/companies" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CompanyForm} />}
          ></Route>
        </Route>
        <Route path="/payment-methods" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PaymentMethodForm} />}
          ></Route>
        </Route>

        {/* INVENTORY */}
        <Route path="/stocks-receiving" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={StocksReceiving} />}
          ></Route>
        </Route>
        <Route
          path="/warehouse-transfer"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={WarehouseTransferForm} />}
          ></Route>
        </Route>
        <Route path="/physical-counts" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PhysicalCountForm} />}
          ></Route>
        </Route>
        <Route
          path="/customer-collections"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CustomerCollectionForm} />}
          ></Route>
        </Route>
        <Route path="/check-vouchers" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CheckVoucherForm} />}
          ></Route>
        </Route>
        <Route path="/stock-transfers" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={StockTransferForm} />}
          ></Route>
        </Route>
        <Route
          path="/replacement-receipts"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ReplacementForm} />}
          ></Route>
        </Route>
        <Route
          path="/display-delivery-receipts"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DisplayDeliveryReceiptForm} />}
          ></Route>
        </Route>
        <Route
          path="/petty-cash-vouchers"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PettyCashVoucherForm} />}
          ></Route>
        </Route>
        <Route path="/sales-returns" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={ReturnStockForm} />}
          ></Route>
        </Route>
        <Route path="/credit-memos" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CreditMemoForm} />}
          ></Route>
        </Route>
        <Route path="/debit-memos" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={DebitMemoForm} />}
          ></Route>
        </Route>
        <Route
          path="/inventory-adjustments"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={InventoryAdjustmentForm} />}
          ></Route>
        </Route>
        <Route
          path="/reports/statement-of-account"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StatementOfAccountForm} />}
          ></Route>
        </Route>
        <Route
          path="/reports/old-statement-of-account"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={OldStatementOfAccountForm} />}
          ></Route>
        </Route>
        <Route
          path="/reports/customer-collection-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CustomerCollectionReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/billing-statement-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={BillingStatementReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/project-estimate-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ProjectEstimateReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/purchase-request-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PurchaseRequestReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/stocks-receiving-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StocksReceivingHistory} />}
          ></Route>
        </Route>

        <Route
          path="/reports/purchase-order-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PurchaseOrderReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/issuance-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={IssuanceReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/warehouse-withdrawal-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={WarehouseWithdrawalReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/return-stock-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ReturnStockReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/processed-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ProcessedReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/inventory-adjustment-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={InventoryAdjustmentReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/delivery-receipts-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DeliveriesReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/physical-count-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PhysicalCountReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/daily-ledgers-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DailyLedgerReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/daily-inventory-ledgers-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DailyInventoryLedgerReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/daily-ledgers-report/:warehouse_id/:date"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DailyLedgerReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/check-voucher-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CheckVoucherReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/project-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ProjectReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/customer-aging-summary"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CustomerAgingSummary} />}
          ></Route>
        </Route>

        <Route
          path="/reports/customer-aging-details"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CustomerAgingDetails} />}
          ></Route>
        </Route>
        <Route
          path="/reports/cash-sales-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CashSalesReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/category-sales-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CategorySalesReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/charge-sales-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ChargeSalesReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/production-history"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ProductionHistory} />}
          ></Route>
        </Route>

        <Route
          path="/delivery-receipts"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DeliveryReceiptForm} />}
          ></Route>
        </Route>

        <Route path="/cash-sales" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={
              <MenuComponent
                component={DeliveryReceiptForm}
                payment_type={PAYMENT_TYPE_CASH}
              />
            }
          ></Route>
        </Route>
        <Route path="/charge-sales" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={
              <MenuComponent
                component={DeliveryReceiptForm}
                payment_type={PAYMENT_TYPE_CHARGE}
              />
            }
          ></Route>
        </Route>

        <Route path="/purchase-returns" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PurchaseReturnForm} />}
          ></Route>
        </Route>
        <Route path="/issuance" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={IssuanceForm} />}
          ></Route>
        </Route>

        <Route
          path="/reports/branch-inventory-balance-list"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={BranchInventoryBalanceList} />}
          ></Route>
        </Route>
        <Route
          path="/reports/stock-card-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StockCardReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/branch-inventory-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={BranchInventoryReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/stock-card-report/:id/:warehouse_id/:date"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StockCardReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/account-ledger"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={AccountLedgerReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/account-ledger-summary"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={AccountLedgerSummaryReport} />}
          ></Route>
        </Route>

        {/* END OF INVENTORY */}

        <Route path="/suppliers" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={SupplierForm} />}
          ></Route>
        </Route>

        {/* PAYROLL */}

        <Route
          path="/scheduled-deductions"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ScheduledDeductionForm} />}
          ></Route>
        </Route>

        <Route path="/deductions" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={DeductionForm} />}
          ></Route>
        </Route>

        <Route path="/attendance" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={AttendanceForm} />}
          ></Route>
        </Route>

        <Route path="/payroll" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={PayrollForm} />}
          ></Route>
        </Route>

        <Route path="/employees" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={EmployeeForm} />}
          ></Route>
        </Route>

        <Route
          path="/reports/payroll-check-voucher-form"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PayrollCheckVoucherForm} />}
          ></Route>
        </Route>

        <Route
          path="/reports/delivery-receipt-items-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={DeliveryReceiptItemsReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/warehouse-receipt-items-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={WarehouseReceiptItemsReport} />}
          ></Route>
        </Route>

        <Route
          path="/reports/leaves-availed-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={LeavesAvailedReport} />}
          ></Route>
        </Route>

        {/* END OF PAYROLL */}

        <Route
          path="/reports/stocks-receiving-history"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StocksReceivingHistory} />}
          ></Route>
        </Route>
        <Route
          path="/reports/replacement-history"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ReplacementReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/petty-cash-voucher-report"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={PettyCashVoucherReport} />}
          ></Route>
        </Route>
        <Route
          path="/reports/stock-transfer-history"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={StockTransferHistory} />}
          ></Route>
        </Route>
        <Route
          path="/reports/credit-memos-history"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={CreditMemoHistory} />}
          ></Route>
        </Route>

        <Route path="/banks" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={BankForm} />}
          ></Route>
        </Route>

        {/* REPORTS */}
        <Route
          path="/reports/all-sales-listings"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={AllSalesListings} />}
          ></Route>
        </Route>
        <Route
          path="/reports/xread-listings"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={XreadListings} />}
          ></Route>
        </Route>
        <Route
          path="/reports/zread-listings"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ZreadListings} />}
          ></Route>
        </Route>

        <Route
          path="/expense-categories"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={ExpenseCategoryForm} />}
          ></Route>
        </Route>

        <Route path="/branches" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={BranchForm} />}
          ></Route>
        </Route>

        <Route path="/other-payments" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={OtherPaymentForm} />}
          ></Route>
        </Route>
        <Route
          path="/other-payment-listings"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={OtherPaymentListings} />}
          ></Route>
        </Route>

        <Route path="/claim-types" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={ClaimTypeForm} />}
          ></Route>
        </Route>
        <Route path="/account-statuses" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={AccountStatusForm} />}
          ></Route>
        </Route>
        <Route path="/collection-types" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={CollectionTypeForm} />}
          ></Route>
        </Route>
        <Route path="/tieups" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={TieupForm} />}
          ></Route>
        </Route>
        <Route path="/tieup-products" element={<PrivateRoute />} exact={true}>
          <Route
            path=""
            element={<MenuComponent component={TieupProductForm} />}
          ></Route>
        </Route>
        <Route
          path="/transaction-types"
          element={<PrivateRoute />}
          exact={true}
        >
          <Route
            path=""
            element={<MenuComponent component={TransactionTypeForm} />}
          ></Route>
        </Route>

        <Route
          path="/print/check-voucher/:id/check"
          element={<CheckPrintout />}
          exact={true}
        />
        <Route
          path="/print/check-vouchers/:id"
          element={<CheckVoucherPrintout />}
          exact={true}
        />

        <Route
          path="/print/purchase-requests/:id"
          element={<PurchaseRequestPrintout />}
          exact={true}
        />

        <Route
          path="/print/purchase-orders/:id"
          element={<PurchaseOrderPrintout />}
          exact={true}
        />
        <Route
          path="/print/issuances/:id"
          element={<IssuancePrintout />}
          exact={true}
        />
        <Route
          path="/print/warehouse-transfers/:id"
          element={<WarehouseTransferPrintout />}
          exact={true}
        />
        <Route
          path="/print/project-estimates/:id"
          element={<ProjectEstimatePrintout />}
          exact={true}
        />

        <Route
          path="/print/warehouse-withdrawals/:id"
          element={<WarehouseWithdrawalPrintout />}
          exact={true}
        />

        <Route
          path="/print/debit-memos/:id"
          element={<DebitMemoPrinout />}
          exact={true}
        />

        <Route
          path="/print/additional-project-estimates/:id"
          element={<AdditionalProjectEstimatePrintout />}
          exact={true}
        />

        <Route
          path="/print/warehouse-returns/:id"
          element={<ReturnStockPrintout />}
          exact={true}
        />

        <Route
          path="/print/stocks-receiving/:id"
          element={<StockReceivingPrintout />}
          exact={true}
        />
        <Route
          path="/print/production/:id"
          element={<ProductionPrinout />}
          exact={true}
        />
        <Route
          path="/print/delivery-receipts/:id"
          element={<DeliveryReportPrintout />}
          exact={true}
        />
        <Route
          path="/print/inventory-adjustments/:id"
          element={<InventoryAdjustmentPrintout />}
          exact={true}
        />
        <Route
          path="/print/customer-collections/:id"
          element={<CustomerCollectionPrintout />}
          exact={true}
        />

        {/*
        <PrivateRoute
          path="/category-products"
          component={CategoryProducts}
          exact={true}
        />
        <PrivateRoute path="/users" component={Users} exact={true} />
        <PrivateRoute
          path="/inventories"
          component={InventoryEntryForm}
          exact={true}
        /> 
        <PrivateRoute
          path="/inventory-review"
          component={InventoryReview}
          exact={true}
        />
        <PrivateRoute
          path="/items-sold-per-category-per-day"
          component={SalesReview}
          exact={true}
        />
        <PrivateRoute
          path="/items-sold-per-category-per-day-other-set"
          component={SalesReview}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/sales-listings"
          component={SalesListings}
          exact={true}
        />
        <PrivateRoute
          path="/sales-listings-other-set"
          component={SalesListings}
          other_set={true}
          exact={true}
        />
        <PrivateRoute
          path="/xread-listings"
          component={XreadListings}
          exact={true}
        />
        <PrivateRoute
          path="/zread-listings"
          component={ZreadListings}
          exact={true}
        />
        <PrivateRoute
          path="/xread-listings-other-set"
          component={XreadListings}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/zread-listings-other-set"
          component={ZreadListings}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/cash-count-report"
          component={CashCountReport}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/voided-sales-listings"
          component={VoidedSalesListings}
          exact={true}
        />
        <PrivateRoute
          path="/voided-sales-listings-other-set"
          component={VoidedSalesListings}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/deleted-orders"
          component={DeletedOrders}
          exact={true}
        />
        <PrivateRoute
          path="/credit-card-sales"
          component={CreditCardSalesListings}
          exact={true}
        />
        <PrivateRoute
          path="/credit-card-sales-other-set"
          component={CreditCardSalesListings}
          other_set={true}
          exact={true}
        />
        <PrivateRoute
          path="/gift-check-sales"
          component={GiftChecksSalesListings}
          exact={true}
        />
        <PrivateRoute
          path="/account-sales"
          component={AccountSalesListings}
          exact={true}
        />
        <PrivateRoute
          path="/account-payment-listings"
          component={AccountPaymentListings}
          exact={true}
        />
        <PrivateRoute
          path="/voided-account-payment-listings"
          component={VoidedAccountPaymentListings}
          exact={true}
        />
        <PrivateRoute
          path="/daily-sales-summary"
          component={DailySalesSummary}
          exact={true}
        />
        <PrivateRoute
          path="/daily-sales-summary-other-set"
          component={DailySalesSummary}
          other_set={true}
          exact={true}
        />
        <PrivateRoute path="/gift-checks" component={GiftChecks} exact={true} />
        
        <PrivateRoute
          path="/credit-cards"
          component={CreditCards}
          exact={true}
        />
        <PrivateRoute
          path="/reports/inventory-balance-report"
          component={BranchInventoryBalanceList}
          exact={true}
        />
        <Route
          path="/order"
          component={(props) => <OrderForm {...props} />}
          exact={true}
        />
        <Route
          path="/cashier"
          component={(props) => <CashierForm {...props} />}
          exact={true}
        />
        <PrivateRoute
          path="/sales-summary"
          component={SalesSummary}
          exact={true}
        />
        
        <PrivateRoute
          path="/developer-settings"
          component={DeveloperSettingsForm}
          exact={true}
        />
        
        <PrivateRoute
          path="/raw-materials-inventory"
          component={RawMaterialsInventory}
          exact={true}
        />
        <PrivateRoute
          path="/discounted-sales-listings"
          component={DiscountedSalesReport}
          exact={true}
        />
        <PrivateRoute
          path="/discounted-sales-listings-other-set"
          component={DiscountedSalesReport}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/sales-returns-listings"
          component={SalesReturnsReport}
          exact={true}
        />
        <PrivateRoute
          path="/virtual-receipts"
          component={VirtualReceiptsDownload}
          exact={true}
        />
        <PrivateRoute
          path="/all-sales-listings"
          component={AllSalesListings}
          exact={true}
        />
        <PrivateRoute
          path="/sales-payment-breakdown"
          component={SalesPaymentBreakdown}
          exact={true}
        />
        <PrivateRoute
          path="/sales-payment-breakdown-other-set"
          component={SalesPaymentBreakdown}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/all-sales-listings-other-set"
          component={AllSalesListings}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/foc-sales-report"
          component={FreeOfChargeSalesReport}
          exact={true}
        />
        <PrivateRoute
          path="/foc-sales-report-other-set"
          component={FreeOfChargeSalesReport}
          other_set={true}
          exact={true}
        />
        <PrivateRoute
          path="/gross-sales-report"
          component={GrossSalesReport}
          exact={true}
        />
        <PrivateRoute
          path="/category-sales-report"
          component={CategorySalesReport}
          exact={true}
        />
        <PrivateRoute
          path="/category-sales-detailed-report"
          component={CategorySalesDetailedReport}
          exact={true}
        />
        <PrivateRoute
          path="/charge-to-account-report"
          component={ChargeToAccountReport}
          exact={true}
        />
        <PrivateRoute
          path="/online-payments-report"
          component={OnlinePaymentsReport}
          exact={true}
        />
        <PrivateRoute
          path="/charge-to-account-report-other-set"
          component={ChargeToAccountReport}
          other_set={true}
          exact={true}
        />
        <PrivateRoute
          path="/consolidated-net-sales-report"
          component={ConsolidatedNetSalesReport}
          exact={true}
        />
        <PrivateRoute
          path="/consolidated-gross-sales-report"
          component={ConsolidatedGrossSalesReport}
          exact={true}
        />
        <PrivateRoute
          path="/gross-sales-report-other-set"
          component={GrossSalesReport}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/sales-by-day-report"
          component={SalesByDayReport}
          exact={true}
        />
        <PrivateRoute
          path="/consolidated-sales-by-day-report"
          component={ConsolidatedSalesByDayReport}
          exact={true}
        />
        <PrivateRoute
          path="/sales-by-day-report-other-set"
          component={SalesByDayReport}
          exact={true}
          other_set={true}
        />
        <PrivateRoute
          path="/audit-trail-report"
          component={AuditTrailReport}
          exact={true}
        />
        
        
        
        <PrivateRoute
          path="/inventory-adjustments"
          component={InventoryAdjustmentForm}
          exact={true}
        />
        <PrivateRoute
          path="/physical-counts"
          component={PhysicalCountForm}
          exact={true}
        />
        <PrivateRoute
          path="/stocks-receiving/:id"
          component={StocksReceiving}
          exact={true}
        />
        <PrivateRoute
          path="/stocks-receiving"
          component={StocksReceiving}
          exact={true}
        />
        <Route
          path="/stocks-receiving-staff"
          element={<StocksReceiving />}
          exact={true}
        />
        <PrivateRoute
          path="/reports/stocks-receiving-history"
          component={StocksReceivingHistory}
          exact={true}
        />
        <PrivateRoute
          path="/reports/inventory-adjustments-history"
          component={InventoryAdjustmentsHistory}
          exact={true}
        />
        <PrivateRoute
          path="/reports/inventory-ledger"
          component={InventoryLedgerReport}
          exact={true}
        />
        <PrivateRoute
          path="/reports/inventory-balance-list"
          component={BranchInventoryBalanceList}
          exact={true}
        />
        <PrivateRoute
          path="/reports/stock-card"
          component={StockCardReport}
          exact={true}
        />
        
        <Route
          path="/print/stocks-receiving/:id"
          element={({ match }) => <ReceivingReportPrintout match={match} />}
          exact={true}
        />
        <Route
          path="/print/physical-counts/:id"
          children={({ match }) => <PhysicalCountPrintout match={match} />}
          exact={true}
        />
        >
        <Route
          path="/register"
          component={(props) => <RegistrationForm {...props} />}
          exact={true}
        /> */}
      </Routes>
    </BrowserRouter>
  </div>
);

export default AppRouter;
